var _defs, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #171954;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.47,13.85h-23.91c-2.45,0-4.44,1.99-4.44,4.44v3.99h4.21v-3.99c0-.13.1-.23.23-.23h23.91c.13,0,.23.1.23.23v38.42c0,.13-.1.23-.23.23h-23.91c-.13,0-.23-.1-.23-.23v-3.99h-4.21v3.99c0,2.45,1.99,4.44,4.44,4.44h23.91c2.45,0,4.44-1.99,4.44-4.44V18.29c0-2.45-1.99-4.44-4.44-4.44Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.92 39.69 40.86 39.69 40.86 35.16 25.9 35.16 25.87 29.05 18.57 33.31 11.27 37.57 18.61 41.76 25.95 45.95 25.92 39.69"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LOGOUT.95bf45e556e8d38ddef0ec347df8cc19.svg";